module.exports = __webpack_public_path__ + "img/omar2.f19e156a.jpg";